import styled from "@emotion/styled";

export const CheckoutFormWrapper = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.space32};
`;

export const AddressFormWrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.space.space16};
`;

export const FormSection = styled.section`
  display: grid;
  gap: ${({ theme }) => theme.space.space24};
`;

export const FieldsGroup = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.space16};
  grid-template-columns: 1fr 1fr;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;
